// extracted by mini-css-extract-plugin
export default {"ResultScoringStep":"ResultScoringView_ResultScoringStep__ZYwXg","botonera":"ResultScoringView_botonera__MTzbb","Alert":"ResultScoringView_Alert__+-Wgf"};